// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"footer-module--disclaimer--1DKRM","base":"footer-module--base--1dPNG","legal":"footer-module--legal--3rKw6"};